export default __webpack_public_path__ + "static/media/BG.088764ac.webp";